// 'use strict';

import './../../components/atoms/background-image/background-image-generic.js';
import './../../components/atoms/background-image/background-image.js';
import './../../components/atoms/button/button.js';
import './../../components/atoms/form-field/form-field.js';
import './../../components/atoms/generic-form/generic-form.js';
import './../../components/atoms/iframe/iframe.js';
import './../../components/atoms/lightbox/lightbox.js';
import './../../components/atoms/link/link.js';
import './../../components/atoms/logo/logo.js';
import './../../components/atoms/picture/picture.js';
import './../../components/atoms/spinner/spinner.js';
import './../../components/atoms/video/video.js';
import './../../components/organisms/exhibition-navigation/exhibition-navigation.js';
import './../../components/organisms/form/form.js';
import './../../components/organisms/grid-slider/grid-slider.js';
import './../../components/organisms/home-banner/home-banner.js';
import './../../components/organisms/home-intro/home-intro.js';
import './../../components/organisms/panels/panels.js';
import './../../components/organisms/photo-slider/photo-slider.js';
import './../../components/organisms/quetzalcoatl/quetzalcoatl.js';
import './../../components/organisms/slider-grid/slider-grid.js';
import './../../components/structures/add-to-calendar/add-to-calendar.js';
import './../../components/structures/become-a-friend/become-a-friend.js';
import './../../components/structures/copyright-confirm/copyright-confirm.js';
import './../../components/structures/copyright/copyright.js';
import './../../components/structures/document/document.js';
import './../../components/structures/follow-us/follow-us.js';
import './../../components/structures/gallery/gallery.js';
import './../../components/structures/infinite-scroll/infinite-scroll.js';
import './../../components/structures/invite-a-friend/invite-a-friend.js';
import './../../components/structures/menu-bar/menu-bar.js';
import './../../components/structures/newsletter-subscribe/newsletter-subscribe.js';
import displayHelloConsoleMessage from './../../vendor/scripts/fabrique/modules/console-hello';
import fireCustomEvent from './../../vendor/scripts/fabrique/modules/fire-custom-event';
import setAllExternalLinksToTargetBlank from './../../vendor/scripts/fabrique/modules/external-links-target-blank';
import showBrowserUpdateMessage from './../../vendor/scripts/fabrique/modules/browser-update';

displayHelloConsoleMessage();
setAllExternalLinksToTargetBlank();
showBrowserUpdateMessage({ vs: { i: 10, f: -2, o: -2, s: 9, c: -5 }, api: 4 }); // TODO: Update this to current browser scope!

// There are 3 load moments:
// - 'init-load' (on parse complete)
// - 'init-content-load' (on DOMContentLoaded)
// - 'init-delayed-load' (500ms after DOMContentLoaded, for iframes and such)
const externalLoadDelay = 500;

window.addEventListener('load', () => fireCustomEvent('init-load'));

document.addEventListener('DOMContentLoaded', () => {
  fireCustomEvent('init-content-load');
  window.setTimeout(() => fireCustomEvent('init-delayed-load'), externalLoadDelay);
});



// WEBPACK FOOTER //
// ./website/assets/scripts/main.js